import React from 'react';
import VariableProximity from './VariableProximity';

const Header = ({ containerRef, currentPage, setCurrentPage }) => {
  return (
    <header>
      <button className="logo" onClick={() => setCurrentPage('home')}>
        <VariableProximity
          label="sukhadapande"
          fromFontVariationSettings="'wght' 400, 'opsz' 9"
          toFontVariationSettings="'wght' 900, 'opsz' 40"
          containerRef={containerRef}
          radius={240}
          falloff="linear"
        />
      </button>
      <nav>
        <button 
          className={currentPage === 'home' ? 'active' : ''} 
          onClick={() => setCurrentPage('home')}
        >
          <VariableProximity
            label="Home"
            fromFontVariationSettings="'wght' 400, 'opsz' 9"
            toFontVariationSettings="'wght' 700, 'opsz' 40"
            containerRef={containerRef}
            radius={80}
          />
        </button>
        <button 
          className={currentPage === 'experiences' ? 'active' : ''} 
          onClick={() => setCurrentPage('experiences')}
        >
          <VariableProximity
            label="Experience"
            fromFontVariationSettings="'wght' 400, 'opsz' 9"
            toFontVariationSettings="'wght' 700, 'opsz' 40"
            containerRef={containerRef}
            radius={80}
          />
        </button>
        <button 
          className={currentPage === 'projects' ? 'active' : ''} 
          onClick={() => setCurrentPage('projects')}
        >
          <VariableProximity
            label="Projects"
            fromFontVariationSettings="'wght' 400, 'opsz' 9"
            toFontVariationSettings="'wght' 700, 'opsz' 40"
            containerRef={containerRef}
            radius={80}
          />
        </button>
      </nav>
    </header>
  );
};

export default Header;